import api from './api';

const BASE = '/api/v1/bench-alerts';

export const benchAlertsService = {
  getPending: () => api.get(`${BASE}/pending`),
  getHistory: () => api.get(`${BASE}/history`),
  getCount: () => api.get(`${BASE}/count`),
  getList: (params) => api.get(BASE, { params }),
  approve: (id, allocationVersion) => 
    api.post(`${BASE}/${id}/approve`, { allocation_version: allocationVersion }),
  changeDate: (id, payload) => 
    api.post(`${BASE}/${id}/change-date`, payload),
  dismiss: (id) => api.post(`${BASE}/${id}/dismiss`),
};
